module.exports = __webpack_public_path__ + "img/91de5b3.gif";